import { z } from "zod";
import { LaboratorySchema } from "./laboratory.entities";

// Énumérations de schémas pour les entités ETL
export enum EtlImportSchemaEnum {
	EtlImport = "EtlImport",
	BaseEtlImport = "BaseEtlImport",
	EtlImportWithPostProcessingReport = "EtlImportWithPostProcessingReport",
	EtlImportWithInsertReport = "EtlImportWithInsertReport",
	EtlImportList = "EtlImportList"
}

const statusReporterSchema = z.object({
	key: z.string(),
	status: z.enum(["todo", "ongoing", "done", "error"]),
	summary: z.string(),
});

const LaboratoryMetaDataSchema = z.object({
	...LaboratorySchema.shape,
});

export type EtlImportLaboratoryMetaData = z.infer<typeof LaboratoryMetaDataSchema>;

const metaDataSchema = z.object({
	// lab data
	laboratories: z.array(LaboratoryMetaDataSchema),
	// pre processing
	unzipSummary: z.record(z.string(), z.record(z.string(), z.object({
		status: z.enum(["running", "done", "error"]),
		summary: z.string().optional(),
	}))),
	processFileInspectSummary: z.object({
		status: z.enum(["running", "done", "error"]),
		summary: z.string().optional(),
	}),
	// ETl
	inputImportStatus: z.array(statusReporterSchema),
	mappingImportStatus: z.array(statusReporterSchema),
	extractImportStatus: z.array(statusReporterSchema),
	dictionaryGenerateStatus: z.array(statusReporterSchema),
	dictionaryProductGenerateStatus: z.array(statusReporterSchema),
	outputGenerationStatus: z.array(statusReporterSchema),
	outputExportStatus: z.array(statusReporterSchema),
	uploadCSVS3BucketStatus: z.enum(["running", "done", "error"]),
	uploadFilesS3BucketStatus: z.enum(["running", "done", "error"]),
	awInsertStatus: z.record(z.string(), z.string()),
});

export const EtlImportSchema = z.object({
	"@id": z.string(), // "/api/imports/e2aaa771-48cf-48ec-a4e7-fbebe3c50ee0"
	"@type": z.string(), // "EtlImport"
	uuid: z.string(), // "e2aaa771-48cf-48ec-a4e7-fbebe3c50ee0"
	source_name: z.enum(['dynamic', 'cosium', 'unknown']),
	company_id: z.number(), // 1
	user_id: z.number(), // 1
	label: z.string(), // "Label"
	hiboutik_subdomain: z.string(),
	hiboutik_token: z.string(),
	meta_data: metaDataSchema.partial(),
	csv_error_report: z.any().optional(),
	insert_error_report: z.any().optional(),
	username: z.string().optional(),
	password: z.string().optional(),
}).describe(EtlImportSchemaEnum.EtlImport);

export const BaseEtlImportSchema = EtlImportSchema.pick({
	"@id": true,
	"@type": true,
	uuid: true,
	source_name: true,
	company_id: true,
	user_id: true,
	label: true,
	username: true,
	password: true,
	// meta_data: true,
}).describe(EtlImportSchemaEnum.BaseEtlImport);

export type BaseEtlImport = z.infer<typeof BaseEtlImportSchema>;

export const BaseEtlImportWithReportSchema = EtlImportSchema.pick({
	csv_error_report: true,
}).describe(EtlImportSchemaEnum.EtlImportWithPostProcessingReport);

export const BaseEtlImportWithInsertReportSchema = EtlImportSchema.pick({
	insert_error_report: true,
}).describe(EtlImportSchemaEnum.EtlImportWithInsertReport);

export const EtlImportListSchema = EtlImportSchema.pick({
	"@id": true,
	"@type": true,
	uuid: true,
	company_id: true,
}).describe(EtlImportSchemaEnum.EtlImportList);

export type EtlImport = z.infer<typeof EtlImportSchema>;
